/*
    url:
        the base url used in our graphql calls.
*/
const host = new URL(window.location).hostname;
let url = 'https://' + host + '/graphql';

if (window.location.protocol !== 'https:') {

    url = 'http://' + host + '/graphql';

}

/*
    limit:
        used to determine the number of results to
        return from each graphql call.
*/
const limit = 12;

/*
    blockId:
        used in our graphql calls to make sure we
        return the filters for the correct block!
*/
const blockId = document.getElementById('tzo-page-list-app').dataset.blockid;

/*
    pageId:
        used in our graphql calls to make sure we
        return the results for the correct page!
*/
const pageId = document.getElementById('tzo-page-list-app').dataset.pageid;

/*
    showSearchField:
        used to tell us whether or not to show
        the text search input field!
*/
const showSearchField = parseInt(document.getElementById('tzo-page-list-app').dataset.showsearchfield, 10);

export const config = {
    url,
    limit,
    blockId,
    pageId,
    showSearchField,
};
